import { GetLinkedinConnectionStatusMeta, GetLinkedinConnectionStatusPayload } from 'types/store/GetLinkedinConnectionStatus';
import { createAsyncReducer } from 'utils/Redux';

import { getLinkedinConnectionStatusActions } from '../actions';

export default createAsyncReducer<GetLinkedinConnectionStatusMeta, GetLinkedinConnectionStatusPayload>(getLinkedinConnectionStatusActions);
